import { render, staticRenderFns } from "./TriAccBl.vue?vue&type=template&id=51e065ed&scoped=true&"
import script from "./TriAccBl.vue?vue&type=script&lang=js&"
export * from "./TriAccBl.vue?vue&type=script&lang=js&"
import style0 from "./TriAccBl.vue?vue&type=style&index=0&id=51e065ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e065ed",
  null
  
)

/* custom blocks */
import block0 from "./TriAccBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports